import React from "react";
import { MarketplaceFilterSettings } from "../MarketplaceFilterSettings";
import { useMarketplaceStore } from "../../../../store/useMarketplaceStore";

export const SourceMarketplaceFilterSettings = () => {
  const selectedCountry = useMarketplaceStore((state) => state.selectedCountry);

  const sourceSettingsConfig = {
    baseSettings: [
      "vendorTypeBlocking",
      "noSalesRankBlocking",
      "unavailableProductsBlocking",
      "sellerNameStartsWithBrandBlocking",
      "discountedProductsBlocking",
      "primeExclusiveProductsBlocking",
    ],
    thresholdMapping: {},
    defaultValues: {
      vendorTypeBlocking: "",
      noSalesRankBlocking: "",
      unavailableProductsBlocking: "",
      sellerNameStartsWithBrandBlocking: "",
      discountedProductsBlocking: "",
      primeExclusiveProductsBlocking: "",
    },
    url: `store/${selectedCountry?.id}/source-marketplace-filter-settings`,
    translateKey: "sourceMarketplaceFilterSettings",
  };

  if (!selectedCountry) {
    return null;
  }

  return <MarketplaceFilterSettings settingsConfig={sourceSettingsConfig} />;
};
